const e = (e2, t) => (a) => (a.target.value = a.target.value.slice(0, e2), t(a));
export {
  e as limitInputLength
};
//# sourceMappingURL=limitInputLength.js.map
